import type { SystemDiskRecord } from '../../../../capabilities/image-vm/types';

/** 系统盘当前镜像身份（用于检测换镜像） */
export function readDiskImageKey(disk: SystemDiskRecord | undefined): string | undefined {
  if (!disk) return undefined;
  const imageId = disk.imageId ?? disk.image?.imageId;
  const url = disk.image?.url;
  const key = String(imageId ?? url ?? '').trim();
  return key || undefined;
}
